import { render, staticRenderFns } from "./ContactModal.vue?vue&type=template&id=28510c7e&"
import script from "./ContactModal.vue?vue&type=script&lang=js&"
export * from "./ContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports